import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "relative flex justify-center h-full w-full text-white w-full h-screen",
  id: "bg-custom"
}
const _hoisted_2 = { class: "flex flex-col space-y-8 backdrop-blur-3xl p-8 w-full h-full overflow-x-auto" }
const _hoisted_3 = { class: "flex flex-col space-y-4 md:flex-row" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "flex flex-col space-y-8 md:pt-8" }
const _hoisted_6 = { class: "absolute bottom-8 right-8 left-8 flex flex-col space-y-8" }
const _hoisted_7 = { class: "flex flex-row space-x-4 mx-auto" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-row space-x-4"
}
const _hoisted_9 = {
  key: 1,
  class: "flex flex-row space-x-4"
}

import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import SliderOval from "@/components/Slider/SliderOval.vue";
import SliderRound from "@/components/Slider/SliderRound.vue";
import TitleBig from "@/components/Titles/TitleBig.vue";
import TitleMedium from "@/components/Titles/TitleMedium.vue";
import TextSmall from "@/components/Texts/TextSmall.vue";
import ButtonPrimary from "@/components/Buttons/ButtonPrimary.vue";
import TitleExtraBig from "@/components/Titles/TitleExtraBig.vue";
import TextMedium from "@/components/Texts/TextMedium.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const currentSlide = ref(0);
const slides: {
  title: string;
  text: string;
  img: string;
}[] = [
  {
    title: "Track Your Journeys",
    text: "Easily mark your visited destinations and plan your future adventures.",
    img: "slider1.svg",
  },
  {
    title: "Customize Map Colors",
    text: "Easily mark your visited destinations and plan your future adventures.",
    img: "slider2.svg",
  },
  {
    title: "Country information",
    text: "Get valuable insights about the countries you explore on your journeys.",
    img: "slider3.svg",
  },
  {
    title: "Connect with friends",
    text: "Stay connected by adding friends to your travel network.",
    img: "slider4.svg",
  },
  {
    title: "Tailor Your Map View",
    text: "Choose between your personal map or a private shared map with selected friends.",
    img: "slider5.svg",
  },
  {
    title: "Download Map as SVG",
    text: "Export your map as an SVG file for easy sharing and printing.",
    img: "slider6.svg",
  },
];

const changeSlide = (index: number) => {
  currentSlide.value = index;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TitleExtraBig, {
        text: "Road Explorer",
        class: "text-left"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: 'img/slider/' + slides[currentSlide.value].img,
          alt: slides[currentSlide.value].img,
          class: "md:w-1/3 mb-4 md:mr-4"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(TitleBig, {
            text: slides[currentSlide.value].title
          }, null, 8, ["text"]),
          _createVNode(TextMedium, {
            text: slides[currentSlide.value].text
          }, null, 8, ["text"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (slide, index) => {
                return _createElementVNode("div", { key: index }, [
                  (index === currentSlide.value)
                    ? (_openBlock(), _createBlock(SliderOval, { key: 0 }))
                    : (_openBlock(), _createBlock(SliderRound, {
                        key: 1,
                        onClick: ($event: any) => (changeSlide(index))
                      }, null, 8, ["onClick"]))
                ])
              }), 64))
            ]),
            (currentSlide.value !== slides.length - 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/login",
                    class: "md:text-lg text-md pt-2 rounded-lg cursor-pointer border w-1/2 text-center border-custom-purple text-custom-purple"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Skip ")
                    ]),
                    _: 1
                  }),
                  _createVNode(ButtonPrimary, {
                    text: "Next",
                    class: "w-1/2",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (changeSlide(currentSlide.value + 1)))
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    to: "/login",
                    class: "w-full text-white md:text-lg text-md px-2 py-2 rounded-lg bg-gradient-to-r from-purple-600 to-indigo-700 cursor-pointer text-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Login ")
                    ]),
                    _: 1
                  })
                ]))
          ])
        ])
      ])
    ])
  ]))
}
}

})